var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42769 0.500001H0.572305C0.459167 0.499824 0.348517 0.529045 0.254382 0.583962C0.160247 0.638878 0.086867 0.717015 0.0435437 0.808468C0.000220468 0.899921 -0.0110944 1.00057 0.0110334 1.09766C0.0331612 1.19474 0.0877351 1.2839 0.167837 1.35381L3.59553 4.35314C3.6486 4.39969 3.71164 4.43663 3.78105 4.46183C3.85045 4.48703 3.92486 4.5 4 4.5C4.07514 4.5 4.14955 4.48703 4.21895 4.46183C4.28836 4.43663 4.3514 4.39969 4.40447 4.35314L7.83216 1.35381C7.91226 1.2839 7.96684 1.19474 7.98897 1.09766C8.01109 1.00057 7.99978 0.899921 7.95646 0.808468C7.91313 0.717015 7.83975 0.638878 7.74562 0.583962C7.65148 0.529045 7.54083 0.499824 7.42769 0.500001Z",
    fill: "#212224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownicon);
export default __webpack_public_path__ + "static/media/dropdownicon.d4d69f422f73d6de34672e63c00a644e.svg";
export { ForwardRef as ReactComponent };